// External
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Internal
import { UiDropdownComponent } from './ui-dropdown.component';
import { DirectivesModule } from '../../directives.module';

@NgModule({
    declarations: [
        UiDropdownComponent
    ],
    imports: [
        CommonModule,
        DirectivesModule
    ],
    exports: [ UiDropdownComponent ]
    
})

export class UiDropdownModule {}
